export default "__VITE_ASSET__Dagg$hAW__"